export default "__VITE_ASSET__Blf6uWap__"